module.exports = __webpack_public_path__ + "static/files/StrinGnosisSaaSAgreement.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/StrinGnosisSaaSAgreement.pdf
// module id = /F5/
// module chunks = 1